import { ChevronRightRounded } from "@mui/icons-material"
import { ButtonBase } from "@mui/material"
import { colors } from "../../../services/config/colors"

export const DesktopControl = ({
  type,
  handleSlideChange,
  disabled,
  hidden,
}: {
  type: "backward" | "forward"
  handleSlideChange: () => void
  disabled?: boolean
  hidden?: boolean
}) => {
  return (
    <ButtonBase
      style={{
        width: 60,
        minWidth: 60,
        height: 60,
        borderRadius: "100%",
        backgroundColor: colors.primary,
        border: `3px solid ${colors.backgroundWhite}`,
        color: colors.textWhite,
        opacity: hidden ? 0 : 1,
        transition: "150ms",
      }}
      disabled={disabled || hidden}
      onClick={handleSlideChange}
    >
      <ChevronRightRounded
        style={{
          fontSize: 32,
          transform: type === "backward" ? "rotate(180deg)" : "none",
        }}
      />
    </ButtonBase>
  )
}
